module.exports = __webpack_public_path__ + "static/media/qr-scanner_function-1.a6093fc1.png";